import React, {useEffect, useRef, useState} from 'react'
import {
    Grid, Icon,
    Paper,
    Typography,
    Fab,
    LinearProgress,
    useMediaQuery
} from '@material-ui/core';
import {useTheme} from '@material-ui/core/styles'
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroller';
import ReactLoading from 'react-loading'
import { useIntl } from 'src/common/razzle-platform-translate'
import { Link } from 'src/common/razzle-platform-components/router'
import NoResults from 'src/common/razzle-platform-map/components/NoResults'
import {HEIGHT} from 'src/common/razzle-platform-map/configs'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'query-string'
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import { useMobileDetector } from 'src/common/razzle-platform-components/hooks/mobile-detector'


function MapSideList(props) {
    const listRef = useRef(null);
    const { formatMessage } = useIntl()
    const location = useLocation()
    let history = useHistory();
    const { isMobile } = useMobileDetector()
    const theme = useTheme()

    const {
        items, handleHoveredElement, hoveredElement, mapView,
        pagination, visible, toggleMap, handleFilterDialog, inProgress,
        setFilter, listItem: ListItem, itemLoader: ItemLoader, updateInProgress,
        itemRoutes
    } = props

    const height = isMobile ? HEIGHT.mobile : ''
    const matches = useMediaQuery('(max-width: 1100px)')
    const [showMapButton, setShowMapButton] = useState(true)

    useEffect(() => {
        if (matches && mapView) toggleMap()
    }, [matches])

    useEffect(() => {
        // handling the appearance of the map and filter buttons
        const handleScroll = () => {
            const elementHeight = document?.querySelector('.products-map-container')?.clientHeight
            if (window?.scrollY >= elementHeight - 500) {
                if (showMapButton) setShowMapButton(false)
            } else {
                if (!showMapButton) setShowMapButton(true)
            }
        }
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [showMapButton])

    const paginationItem = (item) => {
        const searchQuery = {
            ...qs.parse(location.search),
            _page: item.page
        }
        const href = qs.stringifyUrl({ url: location.pathname, query: searchQuery})
        return (
            <PaginationItem
                component={Link}
                to={href}
                {...item}
            />
        )
    }

    const handleMapClick = () => {
        toggleMap()
        const element = document.querySelector('.products-map-container')
        element.scrollIntoView()
    }
    
    return (
        <Paper
            ref={listRef}
            elevation={0}
            style={{
                height: !visible || (mapView && matches) ? '0vh' : mapView ? height : '100%'
            }}
            className={classNames(
                !visible || (mapView && matches) ? 'invisible' : '',
                !mapView && !isMobile ? 'isMobile' : '',
                "w-full max-h-full relative",
            )}
        >
            <span id="paperScrollTarget" />
            
            {updateInProgress && !mapView && !isMobile && <LinearProgress className="relative" color="secondary" style={{ height: 3 }} />}
            
            {isMobile ?
                <InfiniteScroll
                    pageStart={pagination.page}
                    loadMore={() => {
                        if ((pagination.count - items.length > 0) && !updateInProgress) {
                            const searchQuery = {
                                ...qs.parse(location.search),
                                _page: pagination.page + 1
                            }
                            const url = qs.stringifyUrl({ url: location.pathname, query: searchQuery})
                            history.push(url)
                        }
                    }}
                    hasMore={(pagination.count - items.length > 0) && !updateInProgress ? true : false}
                    initialLoad={false}
                    threshold={2000}
                // useWindow={false}
                >
                    <Grid className="flex justify-center" container>
                        {items.length > 0 ?
                            <>
                                {items.map((item, index) =>
                                    {
                                        return (
                                            <Grid
                                                item
                                                xs={12}
                                                md={12}
                                                key={index}
                                                onMouseEnter={() => handleHoveredElement(item.id)}
                                                onMouseLeave={() => handleHoveredElement(null)}
                                            >
                                                <Link to={itemRoutes.details(item)} rel="noopener noreferrer" className="no-underline" >
                                                    <ListItem
                                                        item={item}
                                                        handleMouseEnter={() => handleHoveredElement(item.id)}
                                                        handleMouseLeave={() => handleHoveredElement(null)}
                                                        isHovered={hoveredElement === item.id}
                                                    />
                                                </Link>
                                            </Grid>
                                        )
                                    }
                                )}
                            </> : <NoResults />
                        }
                    </Grid>
                </InfiniteScroll> :
                <>
                    <Grid className="flex justify-center p-4" container>
                        {items.length > 0 ?
                            <>
                                {items.map((item, index) =>
                                    {
                                        return (
                                            <Grid
                                                className="px-2"
                                                item
                                                xs={12}
                                                sm={mapView ? 12 : 6}
                                                key={index}
                                                onMouseEnter={() => handleHoveredElement(item.id)}
                                                onMouseLeave={() => handleHoveredElement(null)}

                                            >
                                                <Link target="_blank" to={itemRoutes.details(item)}>
                                                    <a rel="noopener noreferrer" className="no-underline">
                                                        <ListItem
                                                            item={item}
                                                            isHovered={hoveredElement === item.id}
                                                        />
                                                    </a>
                                                </Link>
                                            </Grid>
                                        )
                                    }
                                )}
                            </> : <NoResults />
                        }
                    </Grid>
                </>
            }


            { updateInProgress && !mapView && isMobile && 
                <div className="flex justify-center" >
                    <ReactLoading type="bars" color={theme.palette.primary.main} width="15%"/>
                </div>
            }
            

            {isMobile && showMapButton && 
                <div style={{
                    bottom: '32px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    position: "fixed",
                    zIndex: 100,
                    display: 'flex',
                }}>
                    <Fab
                    onClick={handleMapClick}
                    size="small"
                    variant="extended"
                    className="bg-white text-base hover:bg-white focus:bg-white"
                    style={{
                        marginRight: '4px',
                        paddingLeft: '.75rem',
                        paddingRight: '.75rem',
                        borderRadius: '1rem',
                    }}
                >
                        <Typography variant="overline" className="text-sm mr-1">{ formatMessage({ id: 'Map', defaultMessage: 'Map' })}</Typography>
                        <Icon className="text-xl">public</Icon>
                    </Fab>
                    <Fab
                        onClick={handleFilterDialog}
                        className="text-white"
                        color="primary"
                        variant="extended"
                        size="small"
                        style={{
                            margin: 0,
                        }}
                        >
                            <Icon className="text-xl">filter_list</Icon>
                            <Typography>{formatMessage({ id: 'Filter', defaultMessage: 'Filter' })}</Typography>
                    </Fab>
                </div>
            }

            {!isMobile && pagination && pagination.count > 0 &&
                <div
                    className='flex items-center justify-center mt-8 mb-4 z-10 bg-white'
                >
                    {/* <Pagination
                        className='flex justify-center'
                        onChange={(page) => {
                            setFilter({_page: page}, true)
                            const element = document.querySelector('#paperScrollTarget')
                            element && element.scrollIntoView({ block: 'end', behavior: 'smooth' })
                        }}
                        itemRender={paginationItemRender}
                        current={pagination.page}
                        total={pagination.count}
                        pageSize={pagination.perPage}
                        locale={localeInfo}
                        showLessItems
                    /> */}
                        <Pagination
                            color="primary"
                            count={Math.ceil(pagination.count / pagination.perPage)}
                            variant="outlined"
                            shape="rounded"
                            page={pagination.page}
                            onChange={(e, page) => {
                                // setFilter({_page: page}, true)
                                const element = document.querySelector('#paperScrollTarget')
                                element && element.scrollIntoView({ block: 'end', behavior: 'smooth' })
                                e.preventDefault()
                            }}
                            renderItem={paginationItem}
                        />

                </div>
            }
        </Paper>
    )
}

export default MapSideList
